//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////// NOTE - any updates to this script need to be copied to all other Wantable Shopify stores as well //////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Cookie functions directly from https://www.w3schools.com/js/js_cookies.asp
const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

const getCookie = (cname) => {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}
// end cookie functions
// This needs to run on all pages in Shopify
// When customers land on Shopify if there are URL parameters or a referer send them to WWW/api/shopify/users/track
//  save the returned GUID in a cookie and append it to links to the WWW site on this and all future pages

(function () {
  const WANTABLE_SESSION_KEY = 'wvid'; // matches Visit::SHOPIFY_VISIT_ID_PARAM
  const WANTABLE_SESSION_EXP_DAYS = 14; // matches Rails session expiry
  const trackPath = '/api/shopify/users/track';

  // global variables
  let listenerAdded = false;
  let currentShop = Shopify.shop;
  let otherSite = 'https://www.wantable.com';

  if(currentShop.includes('staging') || currentShop.includes('sandbox')){
    otherSite = 'https://staging.wantable.com';
  }

  // Outgoing clicks from Shopify to the Wantable need to include a url parameter so that
  // clicks and edit attribution can be associated properly
  function modifyOutboundLinks(wantableSessionId) {
    let links = document.links;
    for (let i = 0; i < links.length; i++) {
      let link = links[i];
      let href = link.href;

      // make outbound links open in new tabs
      if (link.hostname !== window.location.hostname) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
      }

      // rewrite urls that are going to the www site (but not Shop domain)
      // to include this session id
      if (href.indexOf(WANTABLE_SESSION_KEY) < 0 && (href.indexOf(otherSite) >= 0)) {
        link.href = href + (href.indexOf('?') != -1 ? "&" : "?") + WANTABLE_SESSION_KEY + '=' + wantableSessionId;
      }
    }
  }

  function setupOutsideClicks(wantableSessionId) {
    modifyOutboundLinks(wantableSessionId);

    if(!listenerAdded){
      // only add this once and only AFTER we know we want to modify the links
      document.addEventListener("DOMContentLoaded", modifyOutboundLinks);
      listenerAdded = true;
    }
  }

  function sessionIdLooksGood(wantableSessionId) {
    return typeof wantableSessionId === "string" && wantableSessionId !== '' && wantableSessionId.split('-').length === 5
  }

  // create a session on the Wantable side to hold the attribution data for this potential customer
  async function trackUser(wantableSessionId, params) {
    // include current path so we can track where the user landed
    params.path = document.location.pathname;

    // if this isn't the first request then include the session id previously stored
    if(sessionIdLooksGood(wantableSessionId)){
      params.session_id = wantableSessionId;
    }
    (await fetch((otherSite + trackPath), {
      method: "POST",
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(params)
    })).json().then(json => {
      wantableSessionId = json.id;

      // looks like a GUID
      if(sessionIdLooksGood(wantableSessionId)) {
        // make sure outbound clicks
        setupOutsideClicks(wantableSessionId);

        // store the session id for next time
        setCookie(WANTABLE_SESSION_KEY, wantableSessionId, WANTABLE_SESSION_EXP_DAYS);
      }
    });
  }

  ////////////////// Init //////////////////

  // Every page view that has an outside referrer or url parameters should be shared with the Wantable API
  // to detect any outside clicks and correctly attribute visits and future payments to the proper 3rd party
  let params = Object.fromEntries(new URLSearchParams(document.location.search));

  setTimeout(function() {
    let wantableSessionId = getCookie(WANTABLE_SESSION_KEY);

    // include referrer if its not this site so we know where they came from
    if(document.referrer != '' && document.referrer.indexOf(currentShop) < 0){
      params.referer = document.referrer;
    }

    if(Object.keys(params).length > 0){
      params.domain = currentShop;
      trackUser(wantableSessionId, params);
    }
    else if(sessionIdLooksGood(wantableSessionId)){
      // this pageview doesn't need to be tracked but maybe a previous one was
      // rewrite the links if so and make outbound links open in new tabs at least
      setupOutsideClicks(wantableSessionId);
    }
  }, 100);

})();